import { render, staticRenderFns } from "./DisabledDeviceBanner.vue?vue&type=template&id=1c053536&scoped=true&"
import script from "./DisabledDeviceBanner.vue?vue&type=script&lang=js&"
export * from "./DisabledDeviceBanner.vue?vue&type=script&lang=js&"
import style0 from "./DisabledDeviceBanner.vue?vue&type=style&index=0&id=1c053536&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c053536",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c053536')) {
      api.createRecord('1c053536', component.options)
    } else {
      api.reload('1c053536', component.options)
    }
    module.hot.accept("./DisabledDeviceBanner.vue?vue&type=template&id=1c053536&scoped=true&", function () {
      api.rerender('1c053536', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/banners/DisabledDeviceBanner.vue"
export default component.exports